import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { ATTACHMENT_OWNERS } from '../../../core/store/attachments/attachment.model';
import * as layoutActions from '../../../core/store/layout/layout.actions';
import { Asset, Attachment, Event, Group } from '../../../core/store/models';
import { rootSelectors } from '../../../core/store/selectors';

export interface AttachmentUploadModalComponentData {
    owner: Asset | Event | Group;
    uploadMultiple: boolean;
    uploadUrl: string;
}

@Component({
    templateUrl: './attachment-upload-modal.component.html',
    styleUrls: ['./attachment-upload-modal.component.scss'],
    standalone: false
})
export class AttachmentUploadModalComponent implements OnInit, AfterViewInit {
    accept: string;
    owner: any;
    type: string;
    types: string[] = [];
    uploadMultiple: boolean;
    uploadUrl: string;
    ownerType: string;
    disableUpload = false;
    isShowDragContent: boolean = true;
    files: File[] = [];

    constructor(@Inject(MAT_DIALOG_DATA) private data: AttachmentUploadModalComponentData, public dialogRef: MatDialogRef<AttachmentUploadModalComponent>, private store: Store<rootSelectors.State>) { }

    ngOnInit() {
        if (this.data.owner instanceof Asset || Array.isArray(this.data.owner)) {
            this.ownerType = ATTACHMENT_OWNERS.ASSET;
        } else if (this.data.owner instanceof Event) {
            this.ownerType = ATTACHMENT_OWNERS.EVENT;
        } else if (this.data.owner instanceof Group) {
            this.ownerType = ATTACHMENT_OWNERS.GROUP;
        } else {
            this.ownerType = ATTACHMENT_OWNERS.SUBGROUP
        }
        this.uploadMultiple = this.data.uploadMultiple;
        this.uploadUrl = this.data.uploadUrl;
        this.accept = Attachment.ALLOWED_TYPES;
        this.owner = this.data.owner;
    }

    ngAfterViewInit(): void {
        const uploadButtons = Array.from(document.getElementsByClassName('p-button p-component p-disabled') as HTMLCollectionOf<HTMLElement>);
        uploadButtons.forEach(element => {
            element.setAttribute('style', 'background-color: #ff4409 !important; color: white !important;opacity: 1;')
        })
    }


    onBeforeUpload(event: { formData: FormData }) {
        if (this.ownerType === ATTACHMENT_OWNERS.ASSET) {
            const isOwnerArray = Array.isArray(this.owner);
            const studioId = isOwnerArray ? this.owner[0].studio_id : this.owner.studio_id;
            event.formData.append('studio_id', studioId);
            const assetIds = isOwnerArray ? this.owner.map(asset => asset.id) : [this.owner.id];
            event.formData.append(`${this.ownerType}_ids`, JSON.stringify(assetIds));
        } else {
            event.formData.append(`${this.ownerType}_id`, this.owner.id);
        }
        if (this.uploadMultiple) {
            event.formData.append('types', JSON.stringify(this.types));
        } else {
            event.formData.append('type', this.type);
        }

        this.disableUpload = true;
    }

    onSelect(event) {
        const files: FileList = event.files;
        this.type = files.item(0).type;
        if (this.uploadMultiple) {
            for (const file of files as any) {
                this.files.push(file)
                this.types.push(file.type);
            }
        }
        this.isShowDragContent = !(this.files.length > 0);
    }

    onRemove($event) {
        const file = $event.file;
        const index = this.files.findIndex(f => f.name === file.name);
        // remove the files
        if (index > -1) {
            this.types.splice(index, 1);
            this.files.splice(index, 1);
        }

        this.isShowDragContent = this.files.length === 0;
    }

    onUpload(event: { originalEvent: HttpResponse<Attachment>; files: File[] }) {
        const request = event.originalEvent;
        if (request && request.status === 200) {
            try {
                if (Array.isArray(request.body)) {
                    const attachments = request.body.map(att => new Attachment(att));
                    this.dialogRef.close(attachments);
                } else {
                    const attachment = new Attachment(request.body);
                    this.dialogRef.close(attachment);
                }
            } catch (error) {
                this.store.dispatch(new layoutActions.ErrorAction({
                    error
                }));
            }
        }
        this.disableUpload = false;
    }

    onError(error) {
        const message = error?.error?.error?.message;
        this.store.dispatch(new layoutActions.ErrorAction({
            error: new HttpErrorResponse({ error: new Error(message?.includes('Read-Only Access') ? message : 'There was an error uploading the file. We accept files with a max file size of 100MB. If you believe this file was rejected in error, please reach out to support@synconset.com') })
        }));
    }
}
